module.exports = __webpack_public_path__ + "static/media/partner.6701add8.svg";